import { BASE_URL } from '../components/AppConfig';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

const authFetch = async (path, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
    });
    return res.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

const publicFetch = async (path, options = {}) => {
  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
      ...options,
    });
    return res.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

export const isFanEnergyApiSuccess = (res) =>
  String(res?.statusCode || '') === '10000' || res?.statusCode == null;

export const getFanEnergyApiPayload = (res) => res?.data ?? null;

/** GET /admin/fan-energy/dashboard */
export const getFanEnergyDashboard = () =>
  authFetch('/admin/fan-energy/dashboard', { method: 'GET' });

/** Public GET /admin/fan-energy/users */
export const getFanLedgerUsers = ({
  q,
  minFanEnergy,
  sortBy = 'fan_energy',
  sortOrder = 'desc',
  limit = 20,
  offset = 0,
} = {}) => {
  const params = new URLSearchParams({
    sortBy,
    sortOrder,
    limit: String(limit),
    offset: String(offset),
  });
  if (q?.trim()) params.set('q', q.trim());
  if (minFanEnergy !== '' && minFanEnergy != null) params.set('minFanEnergy', String(minFanEnergy));
  return publicFetch(`/admin/fan-energy/users?${params.toString()}`, { method: 'GET' });
};

/** GET /admin/fan-energy/users/:userId */
export const getFanLedgerUser = (userId) =>
  authFetch(`/admin/fan-energy/users/${userId}`, { method: 'GET' });

/** GET /admin/fan-energy/users/:userId/transactions */
export const getFanLedgerTransactions = (
  userId,
  { limit = 50, offset = 0, type, direction, from, to, q } = {}
) => {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  if (type) params.set('type', type);
  if (direction) params.set('direction', direction);
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  if (q?.trim()) params.set('q', q.trim());
  return authFetch(`/admin/fan-energy/users/${userId}/transactions?${params.toString()}`, {
    method: 'GET',
  });
};

/** GET /admin/fan-energy/seasons */
export const getFanEnergySeasons = ({ limit = 24, offset = 0 } = {}) => {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  return authFetch(`/admin/fan-energy/seasons?${params.toString()}`, { method: 'GET' });
};

/** GET /admin/fan-energy/leaderboard/season */
export const getFanEnergySeasonLeaderboard = ({
  seasonId,
  includeGuests = false,
  limit = 50,
  offset = 0,
} = {}) => {
  const params = new URLSearchParams({
    includeGuests: String(includeGuests),
    limit: String(limit),
    offset: String(offset),
  });
  if (seasonId != null && seasonId !== '') params.set('seasonId', String(seasonId));
  return authFetch(`/admin/fan-energy/leaderboard/season?${params.toString()}`, { method: 'GET' });
};

/** GET /admin/fan-energy/leaderboard/daily */
export const getFanEnergyDailyLeaderboard = ({ day, limit = 50, offset = 0 } = {}) => {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  if (day) params.set('day', day);
  return authFetch(`/admin/fan-energy/leaderboard/daily?${params.toString()}`, { method: 'GET' });
};
